import React, { type FunctionComponent } from 'react'
import { css } from '@emotion/react'
import { type ApolloError } from 'apollo-client'
import { type PartnerCallbackResponse } from 'domains/connect/api'
import LoadingDots from 'legacy/components/LoadingDots'
import { fieldsetStyle, legendStyle } from 'domains/connect/components/styles'
import { useDashMessage } from 'intl/intl.hooks'

const textareaStyle = css`
  width: 100%;
  min-height: 400px;
`
interface Props {
  callbackResponse: PartnerCallbackResponse[]
  loading: boolean
  error?: ApolloError
}

export const CallbackTestingResponse: FunctionComponent<Props> = ({
  callbackResponse,
  loading,
  error,
}) => {
  const headerMessage = useDashMessage('connect.callback-testing.response')

  if (loading) {
    return <LoadingDots centered />
  } else if (error) {
    return <div>Error...</div>
  } else if (!callbackResponse) {
    return null
  }

  return (
    <fieldset css={fieldsetStyle}>
      <legend css={legendStyle}>{headerMessage}</legend>
      <textarea
        css={textareaStyle}
        readOnly
        value={JSON.stringify(callbackResponse, null, 2)}
      ></textarea>
    </fieldset>
  )
}
